import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExpandWindow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="none"
    viewBox="0 0 13 13"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M5.244.65H1.569a.92.92 0 0 0-.92.919v9.187c0 .508.412.919.92.919h9.187a.92.92 0 0 0 .919-.919V7.081M8 .65h3.675v3.675M6.163 6.163 11.675.65"
    />
  </svg>
);
export default SvgExpandWindow;
